import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ApiService } from 'src/app/_services/api.service';
import { Operations } from 'src/app/_models/Operations/Operations';
import { GetHostsModelResponse } from 'src/app/_models/Host/HostModel';
import { HostDialogComponent } from '../host-dialog/host-dialog.component';
import { CompanyModel } from 'src/app/_models/Company/CompanyModel';
import { ViewHostDialogComponent } from '../view-host-dialog/view-host-dialog.component';

@Component({
  selector: 'app-host-item',
  templateUrl: './host-item.component.html',
  styleUrls: ['./host-item.component.scss']
})
export class HostItemComponent implements OnInit {

  @Input() host?: GetHostsModelResponse;
  @Input() companyId: string;
  @Input() company: CompanyModel;

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  deactivateHost(hostID: string | undefined) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      operation: Operations.Delete,
      hostId: hostID,
    };

    const dialogRef = this.dialog.open(HostDialogComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed && hostID) {
        this.apiService.deactiveHost(hostID).subscribe(() => {
          this.apiService.getHostsByCompany(this.companyId).subscribe();
        })
      }
    });
  }

  openEditHost(hostID: string | undefined) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      operation: Operations.Edit,
      hostId: hostID,
      host: this.host,
      companyId: this.companyId
    };

    const dialogRef = this.dialog.open(HostDialogComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed) {
        this.apiService.getHostsByCompany(this.companyId).subscribe();
      }
    });
  }

  viewHost(hostID: string  | undefined) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      operation: Operations.Read,
      hostId: hostID,
      host: this.host,
      companyId: this.companyId
    };

    const dialogRef = this.dialog.open(ViewHostDialogComponent, dialogConfig)

    dialogRef.afterClosed().subscribe(closed => {
      if(!closed) {
        this.apiService.getHostsByCompany(this.companyId).subscribe();
      }
    });
  }

}
